import { render, staticRenderFns } from "./JbSupMaterialTestePrincipal.vue?vue&type=template&id=44f5b612&"
import script from "./JbSupMaterialTestePrincipal.vue?vue&type=script&lang=js&"
export * from "./JbSupMaterialTestePrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports